import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { DelayedPageLoader } from '@/components/ui/PageLoader';

export function AdminRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <DelayedPageLoader />;
  }

  if (!user || user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
